import { set } from "@kofile/redux-lenses";
import * as R from "ramda";
import * as utils from "../../utils";
import { newApiTypes, types } from "../actions/platform-reporting";
import * as lenses from "../lenses";

const { platformReporting } = lenses;

export default {
  [newApiTypes.listDashboards]: [
    set(platformReporting.loadingDashboards).as(true),
    set(platformReporting.error).as(null),
  ],

  [newApiTypes.dashboards]: [
    set(platformReporting.dashboards).with(R.propOr([], "payload")),
    set(platformReporting.loadingDashboards).as(false),
  ],

  [newApiTypes.rejectDashboards]: [
    set(platformReporting.error).with(utils.getReason),
    set(platformReporting.loadingDashboards).as(false),
  ],

  [newApiTypes.getEmbedUrl]: [
    set(platformReporting.selectedDashboardId).with(
      R.path(["payload", "dashboardIds", 0])
    ),
    set(platformReporting.embed).as(null),
    set(platformReporting.loadingEmbed).as(true),
    set(platformReporting.error).as(null),
  ],

  [newApiTypes.embedUrl]: [
    set(platformReporting.embed).with(R.path(["payload"])),
    set(platformReporting.loadingEmbed).as(false),
  ],

  [newApiTypes.rejectEmbedUrl]: [
    set(platformReporting.error).with(utils.getReason),
    set(platformReporting.loadingEmbed).as(false),
  ],

  [types.RESET]: [set(platformReporting).as({})],
};
